import { Button } from '@optimus-web/core';
import { FloatingPanel } from '@mews/b2b-ui';
import { LocalizedText, useDialog } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { OptimusProvider, UnsavedChangesDialog } from '@mews-commander/ui';
import { usePortfolioSelectors } from '../utils';
import { CreateRoleForm } from './CreateRoleForm';
import { useCreateRoleFormControls } from './useCreateRoleFormControls';

export const CreateRoleDialog = ({ active, onClose }: { active: boolean; onClose: () => void }) => {
    const [{ active: showUnsavedChangesDialog }, toggleUnsavedChangesDialog] = useDialog();

    const { hasDirtyFields, isLoading, submit, renderFormContent, reset } = useCreateRoleFormControls({
        onSuccess: () => {
            reset();
            onClose();
        },
    });

    const { isPortfolio, isInsidePortfolio } = usePortfolioSelectors();

    const handleClose = () => {
        if (hasDirtyFields) {
            toggleUnsavedChangesDialog();
        } else {
            onClose();
        }
    };

    return (
        <OptimusProvider density="spacious">
            <FloatingPanel
                active={active}
                footer={{
                    primary: (
                        <Button type="submit" variant="primary" onClick={submit}>
                            <LocalizedText textKey={TextKey.Create} />
                        </Button>
                    ),
                }}
                loading={isLoading}
                onClose={handleClose}
                title={
                    <LocalizedText
                        textKey={
                            isInsidePortfolio && !isPortfolio ? TextKey.RoleCreateLocalTitle : TextKey.RoleCreateTitle
                        }
                    />
                }
            >
                {renderFormContent(<CreateRoleForm />)}
            </FloatingPanel>
            <UnsavedChangesDialog
                active={showUnsavedChangesDialog}
                onCancel={toggleUnsavedChangesDialog}
                onDiscardChanges={() => {
                    onClose();
                    toggleUnsavedChangesDialog();
                    reset();
                }}
            />
        </OptimusProvider>
    );
};
